
import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    depId = '',
    search = '',
    sort = [],
    pi = 1,
    ps = 50,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.getMyOrgUserPage, {
        depId,
        search,
        sort,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pc: 0, pi, ps };
};

